import React from 'react';
import { Logo } from '@els/els-react--logo';
import { Button } from '@els/els-react--button';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import LoginPageWrapper from '../Components/LoginPageWrapper';

import './AccessDenied.scss';

function AccessDenied() {
  const handleGoBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(paths.LANDING);
    }
  };

  return (
    <LoginPageWrapper className="react-page-access-denied-page" mainAriaLabel="Access denied screen">
      <div className="access-denied-dialog__content">
        <div className="access-denied-dialog__header">
          <Logo className="access-denied-dialog__logo" />
        </div>

        <h1 className="access-denied-dialog__title u-els-font-size-h4">You do not have access to this page</h1>

        <p className="access-denied-dialog__description">
          If you believe you should have access to this page, please contact your access provider.
        </p>

        <Button
          type="primary"
          expanded
          data-e2e="access-denied-go-back-button"
          className="access-denied-dialog__button e2e-access-denied-go-back"
          onClick={handleGoBack}>
          Go back
        </Button>
      </div>
    </LoginPageWrapper>
  );
}

export default AccessDenied;
